/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiMasterProvinceGetAllProvinceGet } from '../fn/province/api-master-province-get-all-province-get';
import { ApiMasterProvinceGetAllProvinceGet$Params } from '../fn/province/api-master-province-get-all-province-get';
import { apiMasterProvinceGetDistrictByIdGet } from '../fn/province/api-master-province-get-district-by-id-get';
import { ApiMasterProvinceGetDistrictByIdGet$Params } from '../fn/province/api-master-province-get-district-by-id-get';
import { apiMasterProvinceGetSubDistrictByIdGet } from '../fn/province/api-master-province-get-sub-district-by-id-get';
import { ApiMasterProvinceGetSubDistrictByIdGet$Params } from '../fn/province/api-master-province-get-sub-district-by-id-get';
import { District } from '../models/district';
import { Province } from '../models/province';
import { SubDistrict } from '../models/sub-district';

@Injectable({ providedIn: 'root' })
export class ProvinceService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiMasterProvinceGetAllProvinceGet()` */
  static readonly ApiMasterProvinceGetAllProvinceGetPath = '/api/Master/Province/GetAllProvince';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterProvinceGetAllProvinceGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterProvinceGetAllProvinceGet$Response(params?: ApiMasterProvinceGetAllProvinceGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Province>>> {
    return apiMasterProvinceGetAllProvinceGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterProvinceGetAllProvinceGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterProvinceGetAllProvinceGet(params?: ApiMasterProvinceGetAllProvinceGet$Params, context?: HttpContext): Observable<Array<Province>> {
    return this.apiMasterProvinceGetAllProvinceGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Province>>): Array<Province> => r.body)
    );
  }

  /** Path part for operation `apiMasterProvinceGetDistrictByIdGet()` */
  static readonly ApiMasterProvinceGetDistrictByIdGetPath = '/api/Master/Province/GetDistrictById';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterProvinceGetDistrictByIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterProvinceGetDistrictByIdGet$Response(params?: ApiMasterProvinceGetDistrictByIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<District>>> {
    return apiMasterProvinceGetDistrictByIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterProvinceGetDistrictByIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterProvinceGetDistrictByIdGet(params?: ApiMasterProvinceGetDistrictByIdGet$Params, context?: HttpContext): Observable<Array<District>> {
    return this.apiMasterProvinceGetDistrictByIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<District>>): Array<District> => r.body)
    );
  }

  /** Path part for operation `apiMasterProvinceGetSubDistrictByIdGet()` */
  static readonly ApiMasterProvinceGetSubDistrictByIdGetPath = '/api/Master/Province/GetSubDistrictById';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterProvinceGetSubDistrictByIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterProvinceGetSubDistrictByIdGet$Response(params?: ApiMasterProvinceGetSubDistrictByIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubDistrict>>> {
    return apiMasterProvinceGetSubDistrictByIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterProvinceGetSubDistrictByIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterProvinceGetSubDistrictByIdGet(params?: ApiMasterProvinceGetSubDistrictByIdGet$Params, context?: HttpContext): Observable<Array<SubDistrict>> {
    return this.apiMasterProvinceGetSubDistrictByIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SubDistrict>>): Array<SubDistrict> => r.body)
    );
  }

}
